import {AbstractPage} from "./AbstractPage";
import {JqueryApp} from "./JqueryApp";

export class Landing extends AbstractPage {
    protected contactValidated = false;

    constructor(app: JqueryApp) {
        super(app);

        this.app.$(() => { // jQuery 3.0 "document.ready"
            this.initPage();
            //this.addEventListeners();
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected initPage() {
        this.app.$(".contact-comment #comment").removeAttr("required");
        if (window.grecaptcha == undefined)
            return; // disabled

        this.app.$("#contact-form").on("submit", (event) => {
        //this.app.$("#submit-contact").on("click", (event) => {
            if (this.contactValidated === true)
                return;
            this.disableContactButtonTimer();
            event.preventDefault();
            grecaptcha.ready(() => {
                grecaptcha.execute(this.app.getConfig().reCaptchaKey, {action: 'submit'}).then((token) => {
                    this.app.$("#contact-token").val(token);
                    this.contactValidated = true;
                    this.app.$("#contact-form").submit();
                });
            });
        });
    }

    protected disableContactButtonTimer() {
        const confirmButton = $('#submit-contact');
        confirmButton.attr('disabled', "true");
        setTimeout(() => {
            confirmButton.removeAttr('disabled');
        }, 6000);
    }
}
